export default __webpack_public_path__ + "static/media/457.38bd44ed.jpg";